export enum BusinessPolicyLogicalOperatorType {
  AND = 'AND',
  OR = 'OR',
}
